import React, { useState, useContext } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { WalkDataContext } from '../components/hooks/walkDataContext';

const Radio = ({ tracks, handleTrack }) => {
  const [digits, setDigits] = useState(['0', '0', '0', '0']);
  const [message, setMessage] = useState('');
  const { language } = useContext(WalkDataContext);

  const handleDigitChange = (index, value) => {
    const newValue = value.replace(/[^0-9]/g, '');
    if (newValue.length <= 1) {
      const newDigits = [...digits];
      newDigits[index] = newValue || '0';
      setDigits(newDigits);
    }
  };

  const incrementDigit = (index) => {
    const newDigits = [...digits];
    newDigits[index] = newDigits[index] === '9' ? '0' : String(Number(newDigits[index]) + 1);
    setDigits(newDigits);
  };

  const decrementDigit = (index) => {
    const newDigits = [...digits];
    newDigits[index] = newDigits[index] === '0' ? '9' : String(Number(newDigits[index]) - 1);
    setDigits(newDigits);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const number = parseFloat(digits.join(''));

    const matchingTrack = tracks.find(track => {
      const radioValue = parseFloat(track.metadata?.trackMeta_radio?.["1"]);
      return !isNaN(radioValue) && radioValue === number;
    });

    if (matchingTrack) {
      handleTrack(matchingTrack.slug);
      //setMessage('Track found and playing.');
    } else {
      const negativeTracks = tracks.filter(track => {
        const radioValue = parseFloat(track.metadata?.trackMeta_radio?.["1"]);
        return !isNaN(radioValue) && radioValue < 0;
      });

      if (negativeTracks.length > 0) {
        const randomTrack = negativeTracks[Math.floor(Math.random() * negativeTracks.length)];
        handleTrack(randomTrack.slug);
        //setMessage('No matching track found. Playing a random track.');
      } else {
        //setMessage('No matching track found.');
      }
    }
  };

  const currentFrequency = digits.join('');

  return (
    <>
      <div className='title-page title-radio'><h1>Radio</h1></div>
      <Form onSubmit={handleSubmit} aria-label="Radio frequency selector">
        <fieldset className="radio-frequency-fieldset">
          <legend className="visually-hidden">Enter 4-digit radio frequency</legend>
          <div className="d-flex justify-content-center mb-3" role="group" aria-label="Frequency digit controls">
            {digits.map((digit, index) => (
              <div key={index} className="mx-2 text-center frequency-digit-container">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => incrementDigit(index)}
                  aria-label={`Increase digit ${index + 1} of 4, current value ${digit}`}
                  className="digit-increment-button"
                >
                  <FaChevronUp aria-hidden="true" />
                </Button>
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  value={digit}
                  onChange={(e) => handleDigitChange(index, e.target.value)}
                  className="text-center my-2 frequency-digit-input"
                  style={{ width: '40px' }}
                  aria-label={`Digit ${index + 1} of 4-digit frequency, current value ${digit}`}
                />
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => decrementDigit(index)}
                  aria-label={`Decrease digit ${index + 1} of 4, current value ${digit}`}
                  className="digit-decrement-button"
                >
                  <FaChevronDown aria-hidden="true" />
                </Button>
              </div>
            ))}
          </div>
          <div className="text-center">
            <Button variant="primary" type="submit" className="frequency-submit-button" aria-label={`Submit frequency ${currentFrequency}`}>
              Enter Frequency
            </Button>
          </div>
        </fieldset>
      </Form>
      {message && (
        <div role="status" aria-live="polite" className="mt-3">
          <Alert variant="info" className="radio-status-message">{message}</Alert>
        </div>
      )}
    </>
  );
};

export default Radio;